import { RefObject, useState } from 'react';

import hmsToSeconds from '../utility/hmsToSeconds';

type InputDuration = [
  {
    duration: string;
    error: boolean;
  },
  {
    setDuration: (comment: string) => void;
    setVideoRef: (videoRef: RefObject<HTMLVideoElement>) => void;
  },
];

const useInputDuration = (duration = '00:00:00', videoRef: RefObject<HTMLVideoElement>): InputDuration => {
  const [inputDuration, setInputDuration] = useState({ duration: duration, error: false });
  let video = videoRef;

  const setDuration = (duration: string): void => {
    const [time, decimal = '000'] = duration.split('.');

    setInputDuration({
      duration: `${time}.${decimal.padEnd(3, '0')}`,
      error: validationDuration(duration),
    });
  };

  const setVideoRef = (videoRef: RefObject<HTMLVideoElement>) => {
    video = videoRef;
  };

  const validationDuration = (duration: string) => {
    return video.current ? hmsToSeconds(duration) > video.current.duration : false;
  };

  return [inputDuration, { setDuration, setVideoRef }];
};

export default useInputDuration;
